function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "JA_Citizens_PoweredBy_1_",
  "data-name": "JA_Citizens_PoweredBy (1)",
  transform: "translate(-17.4 -51.375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3396",
  "data-name": "Group 3396",
  transform: "translate(17.4 59.739)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1310",
  "data-name": "Path 1310",
  d: "M17.4,73.813V67.4h2.007a4.154,4.154,0,0,1,1,.112,1.542,1.542,0,0,1,.725.613,2.388,2.388,0,0,1-.167,2.509,1.722,1.722,0,0,1-1.506.558H18.125v2.621H17.4Zm.725-3.346h1.338a1.476,1.476,0,0,0,.948-.279,1.082,1.082,0,0,0,.279-.892,1.325,1.325,0,0,0-.167-.669,2.426,2.426,0,0,0-.335-.39,1.938,1.938,0,0,0-.725-.112H18.125Z",
  transform: "translate(-17.4 -67.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1311",
  "data-name": "Path 1311",
  d: "M25.6,72.8a2.724,2.724,0,0,1,.5-1.784,1.648,1.648,0,0,1,2.565,0,2.724,2.724,0,0,1,.5,1.784,2.791,2.791,0,0,1-.5,1.84,1.648,1.648,0,0,1-2.565,0A3.005,3.005,0,0,1,25.6,72.8Zm.669,0a2.144,2.144,0,0,0,.335,1.338,1.059,1.059,0,0,0,.836.446,1.045,1.045,0,0,0,.781-.446,2.844,2.844,0,0,0,0-2.677,1.059,1.059,0,0,0-.836-.446,1.045,1.045,0,0,0-.781.446A2.378,2.378,0,0,0,26.269,72.8Z",
  transform: "translate(-21.027 -68.727)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1312",
  "data-name": "Path 1312",
  d: "M33.671,75.228,32.5,70.6h.669l.613,2.677.223,1,.223-.948.613-2.732h.669l.558,2.677.167.892.223-.892.669-2.677h.613l-1.171,4.628H35.9l-.613-2.788-.167-.781-.781,3.569h-.669Z",
  transform: "translate(-24.08 -68.816)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1313",
  "data-name": "Path 1313",
  d: "M45.288,73.634l.669.112a1.958,1.958,0,0,1-.613,1.115,1.472,1.472,0,0,1-1.059.39A1.586,1.586,0,0,1,43,74.638a2.724,2.724,0,0,1-.5-1.784,3.005,3.005,0,0,1,.5-1.84,1.508,1.508,0,0,1,1.283-.613,1.558,1.558,0,0,1,1.227.613,2.724,2.724,0,0,1,.5,1.784v.223H43.169a2.244,2.244,0,0,0,.335,1.171.974.974,0,0,0,.781.39C44.731,74.582,45.065,74.248,45.288,73.634Zm-2.119-1.283h2.119a1.683,1.683,0,0,0-.279-.892.961.961,0,0,0-.781-.446.9.9,0,0,0-.725.335A1.557,1.557,0,0,0,43.169,72.352Z",
  transform: "translate(-28.503 -68.727)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1314",
  "data-name": "Path 1314",
  d: "M50.1,75.14V70.512h.558v.725a2.986,2.986,0,0,1,.39-.669.6.6,0,0,1,.39-.167,1.159,1.159,0,0,1,.669.279l-.223.725a.89.89,0,0,0-.446-.167.6.6,0,0,0-.39.167.9.9,0,0,0-.223.39,4.911,4.911,0,0,0-.112.948v2.4Z",
  transform: "translate(-31.865 -68.727)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1315",
  "data-name": "Path 1315",
  d: "M56.888,73.634l.669.112a1.958,1.958,0,0,1-.613,1.115,1.472,1.472,0,0,1-1.06.39,1.586,1.586,0,0,1-1.283-.613,2.724,2.724,0,0,1-.5-1.784,3.005,3.005,0,0,1,.5-1.84,1.508,1.508,0,0,1,1.283-.613,1.558,1.558,0,0,1,1.227.613,2.724,2.724,0,0,1,.5,1.784v.223H54.769a2.244,2.244,0,0,0,.335,1.171.974.974,0,0,0,.781.39C56.386,74.582,56.721,74.248,56.888,73.634Zm-2.119-1.283h2.119a1.683,1.683,0,0,0-.279-.892.961.961,0,0,0-.781-.446.9.9,0,0,0-.725.335A2.665,2.665,0,0,0,54.769,72.352Z",
  transform: "translate(-33.635 -68.727)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1316",
  "data-name": "Path 1316",
  d: "M64.032,73.813v-.558a1.317,1.317,0,0,1-.446.5,1.124,1.124,0,0,1-.613.167,1.537,1.537,0,0,1-1.171-.613,2.724,2.724,0,0,1-.5-1.784,3.374,3.374,0,0,1,.223-1.338,2.431,2.431,0,0,1,.558-.836,1.044,1.044,0,0,1,.781-.279,1.271,1.271,0,0,1,.613.167,1.7,1.7,0,0,1,.446.446V67.4h.669v6.413h-.558Zm-2.063-2.342a2.144,2.144,0,0,0,.335,1.338.949.949,0,0,0,.725.446.819.819,0,0,0,.725-.446,2.194,2.194,0,0,0,.279-1.283,2.753,2.753,0,0,0-.279-1.394.89.89,0,0,0-.781-.446.95.95,0,0,0-.725.446A2.661,2.661,0,0,0,61.969,71.471Z",
  transform: "translate(-36.82 -67.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1317",
  "data-name": "Path 1317",
  d: "M73.313,73.813H72.7V67.4h.669v2.286a.864.864,0,0,1,.446-.446,1.076,1.076,0,0,1,.558-.167,1.332,1.332,0,0,1,.781.279,1.662,1.662,0,0,1,.558.781,3.047,3.047,0,0,1,.223,1.338,3.005,3.005,0,0,1-.5,1.84,1.383,1.383,0,0,1-1.171.613,1.124,1.124,0,0,1-.613-.167,1.317,1.317,0,0,1-.446-.5v.558Zm0-2.342a4.323,4.323,0,0,0,.112,1.059,1.023,1.023,0,0,0,.39.558.879.879,0,0,0,1.283-.279,2.144,2.144,0,0,0,.335-1.338,2.661,2.661,0,0,0-.279-1.338.87.87,0,0,0-.725-.446.949.949,0,0,0-.725.446A1.684,1.684,0,0,0,73.313,71.471Z",
  transform: "translate(-41.863 -67.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1318",
  "data-name": "Path 1318",
  d: "M79.779,77.013l-.056-.725a1.089,1.089,0,0,0,.39.056.707.707,0,0,0,.335-.056.557.557,0,0,0,.223-.279c0-.056.112-.279.279-.781L79.5,70.6h.669l.781,2.677c.112.335.167.669.279,1.06a7.43,7.43,0,0,1,.279-1.06l.836-2.677h.669l-1.561,4.684a6.685,6.685,0,0,1-.446,1.227,1.033,1.033,0,0,1-.39.446.6.6,0,0,1-.446.112A.949.949,0,0,1,79.779,77.013Z",
  transform: "translate(-44.871 -68.816)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1319",
  "data-name": "Path 1319",
  d: "M86.9,71.492V70.6h.725v.892Zm0,3.736v-.892h.725v.892Z",
  transform: "translate(-48.145 -68.816)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3398",
  "data-name": "Group 3398",
  transform: "translate(73.081 51.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1320",
  "data-name": "Path 1320",
  d: "M168.808,86.208a1.815,1.815,0,0,1-2.577,0l-4.2-4.2.048,2.911a1.667,1.667,0,0,1-1.766,1.813A1.783,1.783,0,0,1,158.5,84.92V81.293a1.725,1.725,0,0,1,1.145-1.67,4.428,4.428,0,0,0,2.577-2.577,1.841,1.841,0,0,1,1.67-1.145h3.627a1.813,1.813,0,0,1,1.813,1.813,1.667,1.667,0,0,1-1.813,1.766l-2.911-.048,4.2,4.2a1.815,1.815,0,0,1,0,2.577",
  transform: "translate(-146.844 -62.745)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1321",
  "data-name": "Path 1321",
  d: "M168.808,51.925a1.815,1.815,0,0,1,0,2.577l-4.2,4.2,2.911-.048a1.667,1.667,0,0,1,1.813,1.766,1.783,1.783,0,0,1-1.813,1.813h-3.627a1.725,1.725,0,0,1-1.67-1.145,4.428,4.428,0,0,0-2.577-2.577,1.841,1.841,0,0,1-1.145-1.67V53.213a1.813,1.813,0,0,1,1.814-1.813,1.667,1.667,0,0,1,1.766,1.813l-.048,2.911,4.2-4.2a1.859,1.859,0,0,1,2.577,0",
  transform: "translate(-146.844 -51.388)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1322",
  "data-name": "Path 1322",
  d: "M134.612,51.912a1.815,1.815,0,0,1,2.577,0l4.2,4.2-.048-2.911a1.667,1.667,0,0,1,1.766-1.813A1.783,1.783,0,0,1,144.92,53.2v3.627a1.725,1.725,0,0,1-1.145,1.67,4.428,4.428,0,0,0-2.577,2.577,1.771,1.771,0,0,1-1.67,1.145H135.9a1.813,1.813,0,0,1-1.813-1.813,1.667,1.667,0,0,1,1.813-1.766l2.911.048-4.2-4.2a1.815,1.815,0,0,1,0-2.577",
  transform: "translate(-134.075 -51.375)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1323",
  "data-name": "Path 1323",
  d: "M134.612,86.208a1.815,1.815,0,0,1,0-2.577l4.2-4.2-2.911.048a1.667,1.667,0,0,1-1.813-1.766A1.783,1.783,0,0,1,135.9,75.9h3.627a1.725,1.725,0,0,1,1.67,1.145,4.428,4.428,0,0,0,2.577,2.577,1.841,1.841,0,0,1,1.145,1.67V84.92a1.813,1.813,0,0,1-1.813,1.813,1.667,1.667,0,0,1-1.766-1.813l.048-2.911-4.2,4.2a1.859,1.859,0,0,1-2.577,0",
  transform: "translate(-134.075 -62.745)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1324",
  "data-name": "Path 1324",
  d: "M202.8,76c-7.159,0-9.5-5.1-9.5-10.563,0-6.94,3.388-11.838,10.261-11.838a17.22,17.22,0,0,1,4.343.561l-.43,3.827a14.17,14.17,0,0,0-4.152-.663c-3.818,0-5.727,3.113-5.727,7.348,0,4.8,1.861,7.45,5.965,7.45a10.3,10.3,0,0,0,3.961-.919L208,74.981A13.619,13.619,0,0,1,202.8,76",
  transform: "translate(-162.347 -52.538)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1325",
  "data-name": "Path 1325",
  d: "M230.982,59.275H234.9V75.454h-3.913Zm1.909-1.327a2.428,2.428,0,0,1,0-4.848,2.426,2.426,0,0,1,0,4.848",
  transform: "translate(-180.479 -52.277)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1326",
  "data-name": "Path 1326",
  d: "M252.215,75.844c-3.341,0-4.391-1.326-4.391-5.05V62.583H245.2V59.37h2.577V54.422L251.69,53.3v6.07h3.675v3.213H251.69v7.09c0,2.091.477,2.652,1.813,2.652a7.854,7.854,0,0,0,1.909-.255v3.366a13.419,13.419,0,0,1-3.2.408",
  transform: "translate(-187.296 -52.381)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1327",
  "data-name": "Path 1327",
  d: "M273.682,59.275H277.6V75.454h-3.913Zm1.909-1.327a2.428,2.428,0,0,1,0-4.848,2.426,2.426,0,0,1,0,4.848",
  transform: "translate(-201.007 -52.277)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1328",
  "data-name": "Path 1328",
  d: "M289.5,80.328V77.56l6.061-8.924c-.573.048-1.766.048-3.245.048h-2.673V65.2h10.595v2.768L294.272,76.8c.62-.048,2.291-.048,3.436-.048h2.625v3.579Z",
  transform: "translate(-208.48 -57.152)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1329",
  "data-name": "Path 1329",
  d: "M324.42,67.363c-1.623,0-2.72,1.193-2.959,3.007h5.584c.048-1.861-.954-3.007-2.625-3.007m6.395,5.679h-9.354c-.048,2.816,1.384,4.2,4.152,4.2A10.525,10.525,0,0,0,330,76.288l.382,3.007a15.44,15.44,0,0,1-5.393.954c-4.82,0-7.493-2.386-7.493-7.731,0-4.629,2.577-8.018,7.063-8.018,4.391,0,6.347,3.007,6.347,6.729,0,.573-.048,1.145-.1,1.813",
  transform: "translate(-221.72 -56.786)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1330",
  "data-name": "Path 1330",
  d: "M361.706,79.962V70.275c0-1.575-.429-2.529-1.861-2.529-1.957,0-3.532,2.243-3.532,4.916v7.3H352.4V64.834h3.675a17.6,17.6,0,0,1-.191,2.673l.048.048a5.494,5.494,0,0,1,5.154-3.054c3.388,0,4.486,2.2,4.486,4.82V79.915h-3.866Z",
  transform: "translate(-238.414 -56.786)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1331",
  "data-name": "Path 1331",
  d: "M390.536,80.249a21.445,21.445,0,0,1-3.15-.286l.1-3.2a13.625,13.625,0,0,0,3.245.477c1.479,0,2.482-.62,2.482-1.623,0-2.673-6.109-1.145-6.109-6.3,0-2.625,2.148-4.82,6.395-4.82a18.793,18.793,0,0,1,2.768.286l-.143,3.054a10.84,10.84,0,0,0-2.816-.382c-1.527,0-2.243.62-2.243,1.527,0,2.482,6.2,1.384,6.2,6.252,0,3.007-2.625,5.011-6.729,5.011",
  transform: "translate(-254.455 -56.786)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3397",
  "data-name": "Group 3397",
  transform: "translate(145.292 6.838)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1332",
  "data-name": "Path 1332",
  d: "M415.032,65.229v2.816h-.525V65.229H413.6V64.8h2.338v.43Z",
  transform: "translate(-413.6 -64.752)",
  fill: "#008656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1333",
  "data-name": "Path 1333",
  d: "M421.993,67.993l-.239-1.718a6.091,6.091,0,0,1-.1-.811h0a4.431,4.431,0,0,1-.191.62l-.62,1.909h-.573l-.573-1.766a2.247,2.247,0,0,1-.191-.764h0a5.9,5.9,0,0,1-.1.859l-.191,1.67H418.7l.477-3.245h.62l.62,1.861a4.9,4.9,0,0,1,.191.668h0a4.9,4.9,0,0,1,.191-.668l.668-1.909h.62l.477,3.245-.573.048Z",
  transform: "translate(-416.266 -64.7)",
  fill: "#008656"
}))));

var SvgJaCitizensPoweredBy = function SvgJaCitizensPoweredBy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207.273,
    height: 24,
    viewBox: "0 0 207.273 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJaCitizensPoweredBy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/JA_Citizens_PoweredBy.711bcd36.svg";
export { ForwardRef as ReactComponent };